import PropTypes from "prop-types";
import React from "react";
import {
  Row,
  Col,
  Alert,
  Card,
  CardBody,
  Container,
  FormFeedback,
  Input,
  Label,
  Form,
  Button,
  Spinner,
} from "reactstrap";

//redux
import { useSelector, useDispatch } from "react-redux";

import { Link, useNavigate } from "react-router-dom";
import withRouter from "../../Components/Common/withRouter";

// Formik Validation
import * as Yup from "yup";
import { useFormik } from "formik";

// action
import { ForgotPasswordThunk, userForgetPassword } from "../../slices/thunks";

// import images
// import profile from "../../assets/images/bg.png";
import logoLight from "../../assets/images/logo-light.png";
import ParticlesAuth from "../AuthenticationInner/ParticlesAuth";
import { createSelector } from "reselect";

import BNRathiLogo from "../../assets/images/BNRathiLogo.png";
import { showToast } from "../../Components/ToastNotification";
import LoginPageLogo from "../../Components/Common/LoginPageLogo";

const ForgetPasswordPage = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      client_code: "",
    },
    validationSchema: Yup.object({
      client_code: Yup.string().required("Please enter your client code"),
    }),
    onSubmit: (values) => {
      // values.phone = '9116443006';
      dispatch(ForgotPasswordThunk(values, props.router.navigate))
        .then((res) => {
          // console.log("res",res)
          if (res?.code === 200) {
            showToast(res.message, "success");

            navigate("/verify-code", { replace: true, state: res.data });
          } else {
            showToast(res.message, "error");
          }
        })
        .catch((err) => {
          showToast(err, "error");
          // console.log("err", err);
        });
      // navigate("/verify-code",{state:values})
      // dispatch(userForgetPassword(values, props.history));
    },
  });

  const selectLayoutState = (state) => state;
  const loginpageData = createSelector(selectLayoutState, (state) => ({
    user: state.Account.user,
    error: state.Login.error,
    loading: state.Login.loading,
    errorMsg: state.Login.errorMsg,
  }));
  // Inside your component
  const { user, error, loading, errorMsg } = useSelector(loginpageData);

  document.title = "";

  return (
    <ParticlesAuth>
      <div className="auth-page-content">
        <Container>
          <Row className="justify-content-center">
            <Col md={12} lg={10} xl={10} className="">
              <Card className="mt-4 mb-0">
                <CardBody className="p-0">
                  <Row className="m-0 p-0">
                    
                  <LoginPageLogo />
                    <Col xxl={6} xl={6} lg={6} md={6} sm={12} className="p-0">
                      <div className="p-4">
                        <div className="text-center mt-2 mb-4">
                          <h3 className="text-dark mb-1">Forgot Password?</h3>
                          {/* <p className="text-muted fs-p-sm">Verification code will be sent to your registered phone no.</p> */}
                        </div>

                        <Alert
                          className="border-0 alert-warning text-center mb-4"
                          role="alert"
                        >
                          The verification code will be sent to your registered mobile number and email address.
                        </Alert>
                        <div className="">
                          {/* {forgetError && forgetError ? (
                            <Alert color="danger" style={{ marginTop: "13px" }}>
                              {forgetError}
                            </Alert>
                          ) : null}
                          {forgetSuccessMsg ? (
                            <Alert
                              color="success"
                              style={{ marginTop: "13px" }}
                            >
                              {forgetSuccessMsg}
                            </Alert>
                          ) : null} */}
                          <Form
                            onSubmit={(e) => {
                              e.preventDefault();
                              validation.handleSubmit();
                              return false;
                            }}
                          >
                            <div className="mb-4">
                              <Label className="form-label">
                                 Client Code
                              </Label>
                              <Input
                                name="client_code"
                                className="form-control"
                                placeholder="Enter client code"
                                type="text"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.client_code || ""}
                                invalid={
                                  validation.touched.client_code &&
                                  validation.errors.client_code
                                    ? true
                                    : false
                                }
                              />
                              {validation.touched.client_code &&
                              validation.errors.client_code ? (
                                <FormFeedback type="invalid">
                                  <div>{validation.errors.client_code}</div>
                                </FormFeedback>
                              ) : null}
                            </div>

                            <div className="text-center mt-4">
                              <Button
                                color="primary"
                                disabled={error ? null : loading ? true : false}
                                className="btn btn-primary w-100"
                                type="submit"
                              >
                                {loading ? (
                                  <Spinner size="sm" className="me-2">
                                    {" "}
                                    Loading...{" "}
                                  </Spinner>
                                ) : null}
                                Send OTP
                              </Button>
                            </div>
                          </Form>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </CardBody>
              </Card>

              <div className="mt-4 text-center">
                <p className="mb-2 text-white">
                  Wait! I remember my password.{" "}
                  <span
                    onClick={() => {
                      navigate("/login");
                    }}
                    className="fw-semibold text-white text-decoration-underline cursor-pointer"
                  >
                    {" "}
                    Back to Signin{" "}
                  </span>{" "}
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </ParticlesAuth>
  );
};

ForgetPasswordPage.propTypes = {
  history: PropTypes.object,
};

export default withRouter(ForgetPasswordPage);
